// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetGlaromatUserRequestModel from '../../model/get-glaromat-user-request-model';
import UpdateGlaromatUserRequestModel from '../../model/update-glaromat-user-request-model';
import SetAcceptanceRequestModel from '../../model/set-acceptance-request-model';
import GetMeRequestModel from '../../model/get-me-request-model';
import VerifyRequestModel from '../../model/verify-request-model';
import ResendVerificationCodeRequestModel from '../../model/resend-verification-code-request-model';
import SetPasswordRequestModel from '../../model/set-password-request-model';
import GlaromatUserModel from '../../model/glaromat-user-model';
import UserModel from '../../model/user-model';

export default (service: Servicelayer) => ({
  /**  */
  async getGlaromatUser(request: GetGlaromatUserRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-glaromat-user'] ?? 'Me/GlaromatUser';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(GlaromatUserModel.toModel(dto));
  },
  /**  */
  async updateGlaromatUser(request: UpdateGlaromatUserRequestModel, config?: RequestConfig) {
    const requestDTO = UpdateGlaromatUserRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-glaromat-user'] ?? 'Me';
    const response = await service.put<any>(endpointPath, {
      body: {
        id: requestDTO.id,
        links: requestDTO.links,
        creatorId: requestDTO.creatorId,
        creatorName: requestDTO.creatorName,
        created: requestDTO.created,
        modifierId: requestDTO.modifierId,
        modifierName: requestDTO.modifierName,
        modified: requestDTO.modified,
        siHaAgbAccepted: requestDTO.siHaAgbAccepted,
        companyLogoDocumentExternalId: requestDTO.companyLogoDocumentExternalId,
        companyName: requestDTO.companyName,
        companyAddress: requestDTO.companyAddress,
        firstName: requestDTO.firstName,
        lastName: requestDTO.lastName,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async setAcceptance(request: SetAcceptanceRequestModel, config?: RequestConfig) {
    const requestDTO = SetAcceptanceRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-set-acceptance'] ?? 'Me/Accept';
    const response = await service.post<any>(endpointPath, {
      body: {
        acceptGlaromatSihaTermsOfCondition: requestDTO.acceptGlaromatSihaTermsOfCondition,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async getMe(request: GetMeRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-me'] ?? 'core/Me';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(UserModel.toModel(dto));
  },
  /**  */
  async verify(request: VerifyRequestModel, config?: RequestConfig) {
    const requestDTO = VerifyRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-verify'] ?? 'core/Me/Verify';
    const response = await service.post<any>(endpointPath, {
      query: {
        code: requestDTO.code,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async resendVerificationCode(request: ResendVerificationCodeRequestModel, config?: RequestConfig) {
    const requestDTO = ResendVerificationCodeRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-resend-verification-code'] ?? 'core/Me/ResendVerificationCode';
    const response = await service.post<any>(endpointPath, {
      query: {
        email: requestDTO.email,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async setPassword(request: SetPasswordRequestModel, config?: RequestConfig) {
    const requestDTO = SetPasswordRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-set-password'] ?? 'core/Me/SetPassword';
    const response = await service.post<any>(endpointPath, {
      body: {
        email: requestDTO.email,
        oldPassword: requestDTO.oldPassword,
        newPassword: requestDTO.newPassword,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
});
